import $ from "@modules/jquery";
import axios from "@modules/axios";
import "./ads";
import "./buddypress";

if (typeof Foundation !== "undefined") {
  delete Foundation._plugins.reveal;
}

$(document).ready(function () {
  const selectorSelect2 = $("body:not(.wp-admin) .select2");
  if (selectorSelect2.length) {
    selectorSelect2.each(function() {
      const $this = $(this);
      let placeholder = "Maak een keuze uit de lijst";

      // Set specific placeholders based on field name
      if ($this.attr('name') === 'Provincie/plaats') {
        placeholder = "Kies een provincie/plaats";
      } else if ($this.attr('name') === 'Leeftijd') {
        placeholder = "Kies een leeftijd";
      }

      $this.select2({
        placeholder: placeholder,
        allowClear: true,
        language: {
          noResults: function () {
            return "Geen resultaten gevonden…";
          },
          searching: function () {
            return "Zoeken…";
          },
        },
      });
    });
  }

  const deleteFriendshipButton = document.querySelector(
    '.single-friendship a[href="#delete"]'
  );
  if (deleteFriendshipButton) {
    deleteFriendshipButton.addEventListener("click", function () {
      let formData = new FormData();
      formData.append("action", "delete_friendship");
      formData.append("security", frameworkGlobal.delete_friendship_nonce);
      formData.append("post_id", this.dataset.postId);

      if (confirm("'" + this.dataset.postTitle + "' verwijderen?") == true) {
        axios
          .post(frameworkGlobal.ajaxurl, formData)
          .then((response) => {
            const status = response.data;
            if (status) {
              window.location.replace(
                `${frameworkGlobal.delete_friendship_redirect}?verwijderd=${this.dataset.postTitle}`
              );
            }
          })
          .catch((error) => {
            console.log("Error occured while posting order:", error);
          });
      }
    });
  }

  let $answerWrapper = $(".answer-wrapper");
  if ($answerWrapper.length) {
    $("#new-answer").on("click", function () {
      let $li = $answerWrapper.children().first().clone().addClass("new");
      let $input = $(
        '<input class="answ-text" type="text" name="th_new_answers[]">'
      );

      $li.find("input").remove();
      $li.prepend($input);

      $answerWrapper.append($li);
    });

    $answerWrapper.on("click", ".delete-answer", function () {
      $(this).parent("li").remove();
    });
  }

  // Equalize heights of subscription elements
  const equalizeHeights = (selectors, containerSelector) => {
    const $scope = containerSelector
      ? $(containerSelector)
      : $(document);

    if (!$scope.length) return;

    const entries = selectors
      .map((selector) => ({
        selector,
        $els: containerSelector
          ? $scope.find(selector)
          : $(selector),
      }))
      .filter((entry) => entry.$els.length);

    if (!entries.length) return;

    entries.forEach((entry) => entry.$els.css("height", "auto"));

    const maxHeights = entries.map((entry) => {
      let max = 0;
      entry.$els.each(function () {
        const h = $(this).height();
        if (h > max) max = h;
      });
      return max;
    });

    entries.forEach((entry, index) =>
      entry.$els.height(maxHeights[index])
    );
  };

  const subscriptionEqualizerSelectors = [
    ".title-container",
    ".img-container",
    ".details",
    ".price-container",
    ".order-container",
  ];
  const subscriptionEqualizerContainer = ".subscription-grid";

  const runSubscriptionEqualizer = () =>
    equalizeHeights(
      subscriptionEqualizerSelectors,
      subscriptionEqualizerContainer
    );

  runSubscriptionEqualizer();

  $(window).on("load", runSubscriptionEqualizer);

  let resizeTimer;
  $(window).on("resize", () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(runSubscriptionEqualizer, 100);
  });

  $(`${subscriptionEqualizerContainer} img`).each(function () {
    if (this.complete) {
      runSubscriptionEqualizer();
    } else {
      $(this).on("load", runSubscriptionEqualizer);
    }
  });
});

document.addEventListener("favoriteToggled", (event) => {
  if (event.detail.isAdding) {
    event.detail.button.querySelector("span").textContent = "Verwijderen";
  } else {
    event.detail.button.querySelector("span").textContent = "Bewaren";
  }
});

// Handle remove favorite buttons on favorites page
$(document).on("click", ".remove-favorite-btn", function (e) {
  e.preventDefault();
  e.stopPropagation();

  const postId = $(this).data("post-id");
  const $button = $(this);
  const $icon = $button.find("iconify-icon");

  if (
    confirm(
      "Weet je zeker dat je dit artikel uit je favorieten wilt verwijderen?"
    )
  ) {
    // Change icon to loading
    $icon.attr("icon", "fas:spinner").addClass("icon-pulse");
    $button.prop("disabled", true);

    let formData = new FormData();
    formData.append("action", "remove_from_favorites");
    formData.append("security", frameworkGlobal.nonce);
    formData.append("post_id", postId);

    axios
      .post(frameworkGlobal.ajaxurl, formData)
      .then(() => {
        window.location.reload();
      })
      .catch((error) => {
        console.log("Error removing favorite:", error);
        alert("Er is een fout opgetreden bij het verwijderen van het artikel.");

        // Restore button state on error
        $icon
          .attr("icon", "material-symbols-light:delete-forever")
          .removeClass("icon-pulse");
        $button.prop("disabled", false);
      });
  }
});
